// @flow

export function convertDueDateFromAbbrevToFullYear(dueDate: string, yearPrefix: string = '20'): string {
  const regex = /^(\d{2})\/(\d{2})$/;
  const results = regex.exec(dueDate);
  if (!results || results.length < 3) {
    throw new Error(`Due date is not on pattern "mm/yy": ${dueDate}`);
  }
  return `${results[1]}/${yearPrefix}${results[2]}`;
}

export function validateCardDueDatePattern(abbrvDueDate: string): boolean {
  return /^(0[123456789]|1[120])\/\d{2}$/.test(abbrvDueDate);
}

export function validateCardDueDateExpiration(abbrvDueDate: string): boolean {
  const result = /^(\d{2})\/(\d{2})$/.exec(abbrvDueDate);

  if (!result || result.length < 3) {
    return false;
  }

  const [, monthStr, yearAbbrvStr] = result;
  const month = Number(monthStr);
  const year = Number(`20${yearAbbrvStr}`);

  const today = new Date();

  if (year < today.getFullYear()) {
    return false;
  }

  if (year === today.getFullYear()) {
    return month >= (today.getMonth() + 1);
  }

  return true;
}
